module.exports = __webpack_public_path__ + "media/rubber_1.7e3aa59b.webm";